// src/store/slices/availableLocumsSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocumData } from '../../models/directory/locum.model';

interface IAvailableLocumsState {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  locums: ILocumData[];
}

const initialState: IAvailableLocumsState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: true,
  last: true,
  locums: [],
};

interface IAvailableLocumsResponsePayload {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  content: ILocumData[];
}

const availableLocumsSlice = createSlice({
  name: 'availableLocums',
  initialState,
  reducers: {
    updateAvailableLocums(
      state,
      action: PayloadAction<IAvailableLocumsResponsePayload>
    ) {
      const {
        page,
        perPage,
        totalPages,
        totalElements,
        numberOfElements,
        first,
        last,
        content,
      } = action.payload;

      state.page = page;
      state.perPage = perPage;
      state.totalPages = totalPages;
      state.totalElements = totalElements;
      state.numberOfElements = numberOfElements;
      state.first = first;
      state.last = last;
      state.locums = content;
    },
  },
});

export const availableLocumsActions = availableLocumsSlice.actions;
export default availableLocumsSlice.reducer;
